import { ref } from 'vue'
import markdownit from 'markdown-it'

const COPY_FEEDBACK_DURATION = 1000

export function useClipboard() {
	const copySuccess = ref(false)
	const md = markdownit()

	function flashSuccess(): void {
		copySuccess.value = true
		setTimeout(() => {
			copySuccess.value = false
		}, COPY_FEEDBACK_DURATION)
	}

	async function copyImage(imageUrl: string): Promise<ClipboardItem> {
		const response = await fetch(imageUrl)
		const blob = await response.blob()
		return new ClipboardItem({ [blob.type]: blob })
	}

	function copyText(text: string): ClipboardItem {
		const plainBlob = new Blob([text], { type: 'text/plain' })
		const htmlBlob = new Blob([md.render(text)], { type: 'text/html' })
		return new ClipboardItem({ 'text/plain': plainBlob, 'text/html': htmlBlob })
	}

	async function copy({ text, imageUrl }: { text?: string; imageUrl?: string }): Promise<void> {
		try {
			let item: ClipboardItem | undefined
			if (imageUrl) {
				item = await copyImage(imageUrl)
			} else if (text) {
				item = copyText(text)
			}
			if (item) {
				await navigator.clipboard.write([item])
			}
			flashSuccess()
		} catch (error) {
			console.error('Ошибка при копировании', error)
		}
	}

	return {
		copySuccess,
		copy
	}
}
